'use strict';
import sortAlphabetically from 'App/babel/utils/sortAlphabetically';

var countrySelectDir = 'upCountrySelect';

angular
	.module('upDirectives')
	.directive(countrySelectDir, function (Account, CountryCodes, selectHelper, AppService, $q, $translate) {
		return selectHelper.getDirectiveObject(countrySelectDir, {
			resource: Account,
			ajax: false,
			asIds: false,
			idAttr: { field: 'code' },
			titleAttr: { field: 'translated' },
			matcher: function (term, arg2, object) {
				console.log('term and stuff', term, '..', arg2, '..', object);

				return object.translated.toLowerCase().indexOf(term.toLowerCase()) !== -1;
			},
			formatSelection: function (country, container, escape) {
				return escape(country.translated);
			},
			formatResult: function (country, container, query, escape) {
				return escape(country.translated);
			},
			getter: function () {
				return CountryCodes.customer(AppService.getCustomerId())
					.find({})
					.then(function (res) {
						var mapped = _.map(res.data, function (cc) {
							cc.translated = $translate.instant(cc.lang);
							return cc;
						});

						var language = AppService.getSelf().language;

						if (language) {
							mapped.sort(sortAlphabetically('translated', false, language));
						}

						return { data: mapped, metadata: { total: mapped.length } };
					});
			}
		});
	})
	.directive(countrySelectDir + 'Ids', function (Account, CountryCodes, selectHelper, AppService, $q, $translate) {
		return selectHelper.getDirectiveObjectIds(countrySelectDir + 'Ids', {
			resource: Account,
			ajax: false,
			asIds: true,
			idAttr: { field: 'code' },
			titleAttr: { field: 'translated' },
			matcher: function (term, arg2, object) {
				return object.translated.toLowerCase().indexOf(term.toLowerCase()) !== -1;
			},
			formatSelection: function (country, container, escape) {
				return escape(country.translated);
			},
			formatResult: function (country, container, query, escape) {
				return escape(country.translated);
			},
			getter: function () {
				return CountryCodes.customer(AppService.getCustomerId())
					.find({})
					.then(function (res) {
						var mapped = _.map(res.data, function (cc) {
							cc.translated = $translate.instant(cc.lang);
							return cc;
						});

						var language = AppService.getSelf().language;

						if (language) {
							mapped.sort(sortAlphabetically('translated', false, language));
						}

						return { data: mapped, metadata: { total: mapped.length } };
					});
			}
		});
	});
